<template>
    <app-layout title="Dashboard">
        <template #header>
            <page-title title="Dashboard" />
        </template>

        <template #dashboard>
            <div class="mx-5 bg-white overflow-hidden shadow-xl sm:rounded-lg">
                <welcome />
            </div>
        </template>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout.vue'
    import PageTitle from '@/Components/PageTitle.vue'
    import Welcome from '@/Jetstream/Welcome.vue'

    export default {
        components: {
            AppLayout,
            PageTitle,
            Welcome,
        },
    }
</script>
